import React from "react";

const LoaderPost = () => {
  return (
    <center>
      <div class="spinner-border text-warning my-5" role="status">
        🌕
      </div>
    </center>
  );
};

export default LoaderPost;
